import React from "react"

import { withText } from "./withText"
import { RichText } from "../../../Styled/Text"
import { Section } from "./TextStyles"

export const Text = withText(
  ({ content }): JSX.Element => (
    <Section>
      <RichText>{content}</RichText>
    </Section>
  )
)

export default Text
